import React from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Switch } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({ label: { fontSize: 12 } });

function EditSwitch(props) {
  const classes = useStyles();
  const [beginValue, setBeginValue] = React.useState(props.value);
  const [value, setValue] = React.useState(props.value);

  const getField = (write) => {
    return (
      <FormControlLabel
        classes={{ label: classes.label }}
        control={
          <Switch
            color={value !== beginValue ? "secondary" : "primary"}
            checked={value}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => {
              setValue(e.target.checked);
              props.onChange(e.target.checked, setBeginValue);
            }}
            disabled={!write || props.disabled}
            value={value}
          />
        }
        label={props.label}
      />
    );
  };

  return props.authorizationField ? (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return getField(write);
      }}
    />
  ) : (
    getField(true)
  );
}

EditSwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  authorizationField: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default EditSwitch;
